import { USER_OPERATIONS } from 'helper';
import { Confluence } from './interfaces';

export const TEMPLATE_TYPES = new Map([
  [Confluence.ETemplateTypes.DEFAULT, ['Стандартный шаблон', USER_OPERATIONS.CONFLUENCE_MANAGER]],
  [Confluence.ETemplateTypes.LESSON, ['Извлеченные уроки', USER_OPERATIONS.CONFLUENCE_LESSON_MANAGER]],
  [Confluence.ETemplateTypes.POLL, ['Голосование', USER_OPERATIONS.CONFLUENCE_MANAGER]],
]);

export const SECTION_LABELS = new Map<Confluence.ESections, string>([
  [Confluence.ESections.INTERNAL, 'Внутренняя'],
  [Confluence.ESections.CLIENT, 'Клиентская'],
]);

// раздел из query-параметра: неизвестное значение считаем «Внутренней»
export function parseSection(value: string | null): Confluence.ESections {
  return SECTION_LABELS.has(value as Confluence.ESections)
    ? (value as Confluence.ESections)
    : Confluence.ESections.INTERNAL;
}

// суффикс, которым backend разводит одинаковые наименования при клонировании: «(клиентская)»
export function sectionSuffix(section: Confluence.ESections): string {
  return `(${(SECTION_LABELS.get(section) || '').toLowerCase()})`;
}

// наименование копии по умолчанию: имя статьи + раздел, в который её клонируют
export function cloneName(name: string | undefined, section: Confluence.ESections): string {
  return name ? `${name} ${sectionSuffix(section)}` : '';
}

export function flatMenu(menu: Confluence.IMenu): Confluence.IArticle[] {
  let articles: Confluence.IArticle[] = [];

  for (const item of menu) {
    articles.push({ name: item.name, parentId: item.parentId, id: item.menuId });

    if (item.child) {
      articles = articles.concat(flatMenu(item.child));
    }
  }

  return articles;
}

export function findMenuById(menu: Confluence.IMenu, menuId: number): Confluence.IMenuItem | null {
  for (let menuItem of menu) {
    if (menuItem.menuId === menuId) {
      return menuItem;
    }

    let found = findMenuById(menuItem.child || [], menuId);

    if (found) {
      return found;
    }
  }
  return null;
}

export function findParentMenus(menu: Confluence.IMenu, menuId: number): Confluence.IMenu {
  let target = findMenuById(menu, menuId);
  let parents = [];

  while (target && target.parentId !== null) {
    let parent = findMenuById(menu, target.parentId!);

    if (parent) {
      parents.push(parent);
      target = parent; // Update target to its parent to continue the search
    } else {
      break; // If no parent found, exit the loop
    }
  }

  return parents;
}
